/**
 * Adjusts an index to account for a removed item.
 *
 * When an item is removed from an array, items after it shift left by 1 position.
 *
 * Example: [A, B, C, D] with B removed → [A, C, D]
 * - A (index 0) → index 0
 * - C (index 2) → index 1
 * - D (index 3) → index 2
 */
export function adjustIndexForRemovedItem(index, removedIndex) {
  // If the index is before or at the removed item position,
  // no adjustment is needed
  if (index <= removedIndex) {
    return index;
  }

  // If the index is after the removed item,
  // we need to subtract 1 because the removed item has been removed
  return index - 1;
}